function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M25.22 2.12a8.9 8.9 0 011.27.62.53.53 0 01.28.47.54.54 0 01-.59.54c-.27 0-.57-.07-.84-.08-.69-.05-1.37-.08-2.06-.08-8 0-9.37 4.74-9.37 12v3.75h4.29a1.08 1.08 0 011.07 1.07 1.06 1.06 0 01-.32.75l-8.56 8.5a1.05 1.05 0 01-1.51 0L.31 21.09a1.06 1.06 0 01-.32-.75 1.08 1.08 0 011.07-1.07h4.29v-3.75c0-5.49 1-12.32 6.75-14.65a15.1 15.1 0 015.57-.89c2.3.02 5.41 1.19 7.55 2.14z"
});

var SvgMailReply = function SvgMailReply(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 26.78 30"
  }, props), _ref);
};

export default SvgMailReply;